<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Tambah Terminal dan Alokasi</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Masukkan Nama Terminal"
                outlined
                label="Nama Terminal"
                type="text"
                v-model="terminalId"
              ></v-text-field>
              <v-text-field
                placeholder="Masukkan Nomor Serial"
                outlined
                label="Nomor Serial"
                type="text"
                v-model="terminalSerialNumber"
              ></v-text-field>
              <v-select
                v-model="terminalAllocationType"
                :items="allocationTypes"
                menu-props="auto"
                outlined
                placeholder="Alokasi Terminal"
                single-line
                solo
              ></v-select>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Informasi Tambahan</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout wrap justify-space-around>
                <v-flex xs12>
                  <v-autocomplete
                    label="Wahana"
                    hint="Terminal akan membuka gerbang wahana ini"
                    persistent-hint
                    :items="attractions"
                    item-text="attractionName"
                    item-value="id"
                    clearable
                    hide-no-data
                    hide-selected
                    v-model="chosenAttractionId"
                    :disabled="!attractionIsNeeded"
                    class="mb-6"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    label="Outlet"
                    hint="Terminal dipakai untuk penjualan di outlet ini"
                    persistent-hint
                    :items="outlets"
                    item-text="outletName"
                    item-value="id"
                    clearable
                    hide-no-data
                    hide-selected
                    v-model="chosenOutletId"
                    :disabled="!outletIsNeeded"
                    class="mb-6"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 md5>
                      <v-text-field
                        hint="hostname alamat mesin gerbang"
                        persistent-hint
                        placeholder="Masukkan hostname gerbang"
                        outlined
                        label="Hostname Gerbang"
                        type="text"
                        v-model="gateHost"
                        :disabled="!gateMachineAddressIsNedded"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        hint="port alamat mesin gerbang"
                        persistent-hint
                        outlined
                        label="Port Gerbang"
                        type="number"
                        v-model="gatePort"
                        :disabled="!gateMachineAddressIsNedded"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="editData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_TERMINAL_PATH,
      outletPath: process.env.VUE_APP_OUTLET_PATH,
      attractionPath: process.env.VUE_APP_ATTRACTION_PATH,
      allocationTypePath: process.env.VUE_APP_TERMINAL_ALLOCATION_TYPE_PATH,
      terminalId: null,
      terminalSerialNumber: null,
      terminalAllocationType: null,
      chosenAttractionId: null,
      chosenOutletId: null,
      gateHost: null,
      gatePort: null,
      attractions: [],
      outlets: [],
      allocationTypes: []
    };
  },
  methods: {
    editData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      self.terminalMasterId = this.$route.params.id;
      this.axios
        .post(self.mainPath + "/edit", {
          terminalId: self.terminalId,
          terminalSerialNumber: self.terminalSerialNumber,
          terminalAllocationType: self.terminalAllocationType,
          gateHost: self.gateHost,
          gatePort: self.gatePort,
          attractionId: self.chosenAttractionId,
          outletId: self.chosenOutletId,
          id: self.terminalMasterId
        })
        .then(function() {
          self.loadingMessage = "Sukses mengubah data terminal";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchData() {
      let terminalMasterId = this.$route.params.id;
      let self = this;
      this.axios
        .get(self.mainPath + "/" + terminalMasterId)
        .then(function(response) {
          let data = response.data;
          self.terminalId = data.terminalId;
          self.terminalSerialNumber = data.terminalSerialNumber;
          self.terminalAllocationType = data.terminalAllocationType;
          self.gateHost = data.gateHost;
          self.gatePort = data.gatePort;
          self.chosenAttractionId = data.attractionId;
          self.chosenOutletId = data.outletId;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchAllocationTypes() {
      let self = this;
      this.axios
        .get(self.allocationTypePath)
        .then(function(response) {
          self.allocationTypes = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchOutlets() {
      let self = this;
      this.axios
        .get(self.outletPath)
        .then(function(response) {
          self.outlets = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchAttractions() {
      let self = this;
      this.axios
        .get(self.attractionPath)
        .then(function(response) {
          self.attractions = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    }
  },
  computed: {
    successScrollOptions() {
      return {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic"
      };
    },
    attractionIsNeeded() {
      return this.terminalAllocationType === "ATTRACTION_IN_GATE";
    },
    outletIsNeeded() {
      return this.terminalAllocationType === "OUTLET";
    },
    gateMachineAddressIsNedded() {
      return (
        this.terminalAllocationType === "ATTRACTION_IN_GATE" ||
        this.terminalAllocationType === "PARKING_IN_GATE" ||
        this.terminalAllocationType === "PARKING_OUT_GATE"
      );
    }
  },
  mounted: function() {
    this.fetchAllocationTypes();
    this.fetchOutlets();
    this.fetchAttractions();
    this.fetchData();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
